<template>
  <div id="app">
    <MainLayout />
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout'

export default {
  components: { MainLayout },
}
function jsUpdateSize(){
    // Get the dimensions of the viewport
   var width = window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
      
      if ( width > 1224) {
        document
          .querySelector('meta[name=viewport]')
          .setAttribute('content', 'width=device-width, initial-scale=1.0')
      
      }else if ( width > 700 ) {
        document
          .querySelector('meta[name=viewport]')
          .setAttribute('content', 'width=device-width, initial-scale=0.6 , user-scalable=no')
      } else if ( width < 550) {
        document
          .querySelector('meta[name=viewport]')
          .setAttribute('content', 'width=device-width, initial-scale=1.0')
      } 
};
 
window.onload = jsUpdateSize;      
// window.onresize = jsUpdateSize;    

</script>

